import { MantineTheme } from '@mantine/core';

export const applyTableStyles = (theme: MantineTheme) => ({
  '&&': {
    '>table': {
      '>thead > tr > th, >tbody > tr > td': {
        '&:first-of-type': {
          minWidth: 'unset',
          width: 1,
          paddingRight: theme.other.spacing(2),
        },
        '&:nth-of-type(2)': { paddingLeft: theme.other.spacing(2) },
      },
    },
  },
});
